module.exports = __webpack_public_path__ + "static/img/cpzx_tu14.c4230b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/spzx_xqy/cpzx_tu14.png
// module id = Jlvy
// module chunks = 1